module.exports = __webpack_public_path__ + "static/media/vignan_logo.52bb202d.png";